import React, { useContext } from "react";
import Spinner from "react-bootstrap/Spinner";
import { ConditionalWrapper } from "../ConditionalWrapper";
import { AppContext } from "../../domain/App/AppContext";

const Loader = props => {
  const inProgress = useContext(AppContext).promiseInProgress;

  return (
    inProgress && (
      <ConditionalWrapper
        condition={!props.inline}
        wrapper={children => (
          <div className="row d-flex justify-content-center align-self-center">
            {children}
          </div>
        )}
      >
        <Spinner
          animation={props.animation}
          variant={props.variant}
          size={props.size}
          as={props.as}
          role={props.role}
        />
      </ConditionalWrapper>
    )
  );
};

Loader.defaultProps = {
  inline: false,
  animation: "border",
  variant: "primary",
  size: ""
};

export default Loader;
